import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import { SalesInvoice } from "../../../../interfaces/Sales/Invoices/salesinvoices";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useParamsFilter } from "../../../../hooks/useParamsFilter";
import { useDates } from "../../../../hooks/useDates";
import { useFormatNumber } from "../../../../hooks/useFormatNumber";

export const useSalesInvoiceColumns = () => {
    const [t] = useTranslation("global");
    const { ConvertParamsToBase64 } = useParamsFilter();
    const { TimeConverter } = useDates();
    const { setFormatNumberFromTable } = useFormatNumber();
    const columnsSalesInvoices: GridColDef<SalesInvoice>[] = [
        { field: 'sales_invoice_name', headerName: t("salesinvoices.fields.sales_invoice_name"), headerClassName: 'header-grid-table', flex: 1 },
        {
            field: 'project_name', headerName: t("projects.fields.project_name"), headerClassName: 'header-grid-table', flex: 1,
            renderCell(params) {
                return <Button disabled={(params.row.project_name) ? false : true} onClick={() => {
                    let stringConverted = ConvertParamsToBase64(`project_id=${params.row.project_id}`);
                    window.open(`/projects/view?${stringConverted}`, '_blank');
                }}>
                    {params.row.project_name}
                </Button>
            }
        },
        { field: 'uuid', headerName: t("salesinvoices.fields.uuid"), headerClassName: 'header-grid-table', flex: 1 },
        {
            field: 'sales_invoice_date', headerName: t("salesinvoices.fields.sales_invoice_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
            valueGetter(params) {
                return TimeConverter(params.value);
            },
        },
        { field: 'customer_business_name', headerName: t("salesinvoices.fields.customer_business_name"), headerClassName: 'header-grid-table', flex: 1 },
        { field: 'purchase_order', headerName: t("salesinvoices.fields.purchase_order"), headerClassName: 'header-grid-table', flex: 1 },
        { field: 'invoice_doc_status_name', headerName: t("salesinvoices.fields.invoice_doc_status_name"), headerClassName: 'header-grid-table', flex: 1 },
        { field: 'currency_code', headerName: t("currencies.title-view"), headerClassName: 'header-grid-table', flex: 1 },
        {
            field: 'subtotal_amount', headerName: t("salesinvoices.fields.subtotal_amount"), headerClassName: 'header-grid-table', flex: 1, type: 'number', align: "left", headerAlign: "left",
            valueGetter(params) {
                return setFormatNumberFromTable(params.value ?? 0);
            },
        },
        {
            field: 'tax_amount', headerName: t("salesinvoices.fields.tax_amount"), headerClassName: 'header-grid-table', flex: 1, type: 'number', align: "left", headerAlign: "left",
            valueGetter(params) {
                return setFormatNumberFromTable(params.value ?? 0);
            },
        },
        {
            field: 'retention_amount', headerName: t("salesinvoices.fields.retention_amount"), headerClassName: 'header-grid-table', flex: 1, type: 'number', align: "left", headerAlign: "left",
            valueGetter(params) {
                return setFormatNumberFromTable(params.value ?? 0);
            },
        },
        {
            field: 'total_amount', headerName: t("salesinvoices.fields.total_amount"), headerClassName: 'header-grid-table', flex: 1, type: 'number', align: "left", headerAlign: "left",
            valueGetter(params) {
                return setFormatNumberFromTable(params.value ?? 0);
            },
        },
        {
            field: 'total_company_currency_amount', headerName: t("companies.configuration.fields.total_company_currency_amount"), headerClassName: 'header-grid-table', flex: 1,
            valueGetter(params) {
                return setFormatNumberFromTable(params.value ?? 0);
            },
        },
        { field: 'user_mail_send', headerName: t("salesinvoices.fields.user_mail_send"), headerClassName: 'header-grid-table', flex: 1 },
        {
            field: 'date_mail_send', headerName: t("salesinvoices.fields.date_mail_send"), headerClassName: 'header-grid-table', flex: 1,
            valueGetter(params) {
                return TimeConverter(params.value);
            },
        },
        {
            field: 'creation_date', headerName: t("generic.creation_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
            valueGetter(params) {
                return TimeConverter(params.value);
            },
        },
        { field: 'last_update_user', headerName: t("generic.last_update_user"), headerClassName: 'header-grid-table', flex: 1 },
        {
            field: 'last_update_date', headerName: t("generic.last_update_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
            valueGetter(params) {
                return TimeConverter(params.value);
            },
        },
    ];

    return {
        columnsSalesInvoices
    };
}
